import { render, staticRenderFns } from "./WindowOpeningType.vue?vue&type=template&id=0f5dc8fc&"
import script from "./WindowOpeningType.vue?vue&type=script&lang=js&"
export * from "./WindowOpeningType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports